import React, { Component } from "react";
import { Card, Col, Container, Form, Row, Button } from "react-bootstrap";
// import "./PoliciesFormPage.css";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import configData from "../config.json";

import { getYear, getMonth } from "date-fns";
export default class Zunopolicyformpage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      policies: [],
      isEditing: false,
      editIndex: null,
      fname: "",
      lname: "",
      mobile: "",
      zipcode: "",
      plantype: "1",
      covertype: "",
      suminsured: "",
      Pincode: "",
      tenure: "",
      businesstype: "",
      Health: [],

      isButtonDisabled: false,
      relations: [
        { key: "self", value: "self", isDisabled: false },
        { value: "father", key: "Father", isDisabled: false },
        { value: "mother", key: "Mother", isDisabled: false },
        { value: "sister", key: "Sister", isDisabled: false },
        { value: "brother", key: "Brother", isDisabled: false },
        { value: "spouse", key: "Spouse", isDisabled: false },
        { value: "child1", key: "Son", isDisabled: false },
        { value: "child2", key: "Daughter", isDisabled: false },
        { value: "father-in-law", key: "Father-In-Law", isDisabled: false },
        { value: "mother-in-law", key: "Mother-In-Law", isDisabled: false },
        { value: "brother-in-law", key: "Brother-In-Law", isDisabled: false },
        { value: "niece", key: "Niece", isDisabled: false },
        { value: "nephew", key: "Nephew", isDisabled: false },
        { value: "sister-in-law", key: "Sister-In-Law", isDisabled: false },
        { value: "son-in-law", key: "Son-In-Law", isDisabled: false },
        { value: "daughter-in-law", key: "Daughter-In-Law", isDisabled: false },
        { value: "grand-father", key: "Grand-Father", isDisabled: false },
        { value: "grand-mother", key: "Grand-Mother", isDisabled: false },
        { value: "grand-child", key: "Grand-Child", isDisabled: false },
      ],
      rows: [{ id: 1 }],
      elements: [],
      disableGenderRelations: [
        "mother",
        "mother-in-law",
        "father",
        "father-in-law",
        "self",
        "spouse",
      ],
      errorMessage: "",
      contrast: 100,
      policiesData: {
        relation: "",
        birthDate: null,
        gender: "MALE",
        age: 0,
      },
      error: "",
      setSelf: "",
      puser: null,
      forgotPasswordCondition: false,
    };
  }
  handleEditClick = (index) => {
    const selectedPolicy = this.state.policies[index];
    this.setState({
      policiesData: { ...selectedPolicy },
      isEditing: true,
      editIndex: index,
    });
  };

  handleSaveClick = () => {
    const { policies, policiesData, editIndex } = this.state;
    policies[editIndex] = { ...policiesData };

    this.setState({
      policies,
      policiesData: {
        relation: "",
        birthDate: "",
        age: "",
        gender: "MALE",
      },
      isEditing: false,
      editIndex: null,
    });
  };
  relationChange = (e) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;

    // Set gender based on the selected relation
    let genderValue = "MALE"; // Default to "Male" for most relations

    if (
      fieldValue === "mother" ||
      fieldValue === "sister" ||
      fieldValue === "daughter" ||
      fieldValue === "mother-in-law" ||
      fieldValue === "spouse" ||
      fieldValue === "niece" ||
      fieldValue === "grand-mother" ||
      fieldValue === "grand-child" ||
      fieldValue === "daughter-in-law" ||
      fieldValue === "sister-in-law"
    ) {
      genderValue = "FEMALE"; // Set to "Female" for Mother, Sister, Daughter, Mother-In-Law
    } else if (
      fieldValue === "father" ||
      fieldValue === "brother" ||
      fieldValue === "son" ||
      fieldValue === "father-in-law" ||
      fieldValue === "nephew" ||
      fieldValue === "son-in-la" ||
      fieldValue === "grand-father" ||
      fieldValue === "grand-child" ||
      fieldValue === "brother-in-law"
    ) {
      genderValue = "MALE"; // Set to "Male" for Father, Brother, Son, Father-In-Law
    }

    this.setState((prevState) => ({
      policiesData: {
        ...prevState.policiesData,
        [fieldName]: fieldValue,
        gender: genderValue, // Set the gender based on the relation
      },
      visibletype: fieldValue,
    }));

    // Disable gender selection if the selected relation is one of the specified relations
    const disableGenderRelations = [
      "MOTH",
      "SISTER",
      "DAUGHTER",
      "MLAW",
      "FATH",
      "BROTHER",
      "SON",
      "FLAW",
    ];
    if (disableGenderRelations.includes(fieldValue)) {
      this.setState((prevState) => ({
        disableGender: true,
      }));
    } else {
      this.setState((prevState) => ({
        disableGender: false,
      }));
    }
  };
  handleDateChange = (date) => {
    const ninetyOneDaysAgo = new Date();
    ninetyOneDaysAgo.setDate(ninetyOneDaysAgo.getDate() - 91);

    if (date && date < ninetyOneDaysAgo) {
      // Ensure date is not null or undefined
      const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;

      this.setState((prevState) => ({
        policiesData: {
          ...prevState.policiesData,
          birthDate: formattedDate,
        },
      }));
    } else {
      toast.error("Age should be at least 91 days", "error");
    }
  };

  ageChange = (e) => {
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;
    this.setState((prevState) => ({
      policiesData: {
        ...prevState.policiesData,
        [fieldName]: fieldValue,
      },
    }));
  };
  genderChange = (e) => {
    e.preventDefault();
    const fieldName = e.target.getAttribute("name");
    const fieldValue = e.target.value;
    this.setState((prevState) => ({
      policiesData: {
        ...prevState.policiesData,
        [fieldName]: fieldValue,
      },
      visibletype: fieldValue,
    }));
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "fname") {
      const lettersAndSpacesRegex = /^[A-Za-z\s]*$/;
      if (!lettersAndSpacesRegex.test(value) && value !== "") {
        toast.error("Not allowed special characters and Numbers.");

        return;
      }
    }
    if (name === "lname") {
      const lettersAndSpacesRegex = /^[A-Za-z\s]*$/;
      if (!lettersAndSpacesRegex.test(value) && value !== "") {
        toast.error("Not allowed special characters and Numbers.");

        return;
      }
    }
    if (name === "zipcode" && value.length > 0 && value.charAt(0) === "0") {
      // Display an error toast message or handle the error as needed
      toast.error("Zipcode cannot start with the number 0.");
      return; // Stop further processing for this field
    }

    if (name === "mobile" && value.length > 0) {
      const firstDigit = parseInt(value.charAt(0), 10);

      if (firstDigit < 6 || firstDigit > 9) {
        // Display an error toast message or handle the error as needed
        toast.error("Please enter valid mobile number.");
        return; // Stop further processing for this field
      }
    }
    this.setState({
      [name]: value,
      errors: {
        ...this.state.errors,
        [name]: "", // Clear the corresponding error when the field value changes
      },
    });
  };
  showToast = (msg, type) => {
    var tType = toast.TYPE.INFO;
    if (type === "success") tType = toast.TYPE.SUCCESS;
    if (type === "error") tType = toast.TYPE.ERROR;
    if (type === "warning") tType = toast.TYPE.WARNING;
    toast(msg, { type: tType });
  };
  handleRemoveSpecificRowS = (idx) => {
    const tempRows = this.state.policies; // to avoid  direct state mutation.
    var relDict = tempRows[idx];
    tempRows.splice(idx, 1);
    this.setState({ policies: tempRows });
    var relations = this.state.relations;
    const disableGenderRelations = this.state.disableGenderRelations;
    relations.forEach(function (item) {
      if (
        item.value === relDict.relation &&
        disableGenderRelations.includes(relDict.relation)
      ) {
        item.isDisabled = false;
      }
    });
    var setSelf = "";
    tempRows.forEach((element) => {
      if (element.relation === "SPSE" || element.relation === "SELF") {
        setSelf = element.gender;
      }
    });
    this.setState({ setSelf: setSelf });
  };
  validateDateOfBirth = () => {
    const currentDate = new Date();
    // const selectedDate = new Date(this.state.policiesData.birthDate);

    // Calculate minimum and maximum allowed dates
    const minDate = new Date();
    minDate.setDate(currentDate.getDate() - 91);

    const maxDate = new Date();
    maxDate.setFullYear(currentDate.getFullYear() - 60);

    return true;
  };
  handleAddClick = (e) => {
    e.preventDefault();
    const { policiesData } = this.state;
    // Check if the required fields are empty
    if (
      !this.state.policiesData.relation ||
      !this.state.policiesData.birthDate ||
      !this.state.policiesData.gender
    ) {
      // Show a warning toast message
      this.showToast("Please fill in all fields before adding a row", "error");
      return; // Do not add the row if fields are not filled
    }
    if (policiesData.relation === "SELF") {
      if (this.state.setSelf !== policiesData.relation) {
        this.setState({
          setSelf: policiesData.gender,
        });
      }
      if (policiesData.gender === this.state.setSelf) {
        this.showToast("Self and spouse genders cannot be same.", "error");
        return;
      }
    }
    if (policiesData.relation === "SPSE") {
      if (this.state.setSelf !== policiesData.relation) {
        this.setState({
          setSelf: policiesData.gender,
        });
      }
      if (policiesData.gender === this.state.setSelf) {
        this.showToast("Self and spouse genders cannot be same.", "error");
        return;
      }
    }

    // Additional validation for the "Father" relation

    // Create a new object for the current row with the same values as policiesData
    const newRow = {
      relation: policiesData.relation,
      birthDate: policiesData.birthDate,
      age: policiesData.age,
      gender: policiesData.gender,
    };

    // Add the new row to the policies array
    this.setState((prevState) => ({
      policies: [...prevState.policies, newRow],
    }));
    var relations = this.state.relations;
    const disableGenderRelations = this.state.disableGenderRelations;
    relations.forEach(function (item) {
      if (
        item.value === policiesData.relation &&
        disableGenderRelations.includes(policiesData.relation)
      ) {
        item.isDisabled = true;
      }
    });
    this.setState({ relations: relations });
    // Clear policiesData for the next row
    this.setState({
      policiesData: {
        relation: "",
        birthDate: "",
        gender: "MALE",
        age: 0,
      },
    });

    let maxage = 0;
    let minage = 0;
    this.state.policies.forEach(function (item) {
      if (minage === 0) minage = item.age;
      if (item.age > maxage) maxage = item.age;
      if (item.age < minage) minage = item.age;
      item.dob = item.birthDate;
    });

    if (maxage >= 97) {
      this.setState((prevState) => ({
        tenure: "1 Year",
      }));
    }
  };

  handleRemoveClick = (id) => {
    const { rows } = this.state;
    const updatedRows = rows.filter((row) => row.id !== id);
    this.setState({ rows: updatedRows });
  };
  componentDidUpdate(preProps, prevState) {
    if (
      prevState.policiesData.birthDate !== this.state.policiesData.birthDate
    ) {
      this.calculateAge();
    }
  }
  calculateAge() {
    const birthDate = new Date(this.state.policiesData.birthDate);
    const today = new Date();
    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    let days = today.getDate() - birthDate.getDate();

    if (days < 0) {
      months--;
      days += new Date(today.getFullYear(), today.getMonth(), 0).getDate();
    }

    if (months < 0) {
      years--;
      months += 12;
    }
    if (years === 24 && months === 11 && days > 29) {
      years++;
    }
    if (years === 60 && months === 11 && days > 29) {
      years++;
    }
    const fieldName = "age";
    this.setState((prevState) => ({
      policiesData: {
        ...prevState.policiesData,
        [fieldName]: years,
      },
      visibletype: years,
    }));
  }

  onKeyDown = (event) => {
    if (event.key === " ") {
      event.preventDefault();
      toast.error("Spaces are not allowed.");
    }
  };
  formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  handleSubmitClick = (e) => {
    e.preventDefault();
    this.handleSubmit();
    this.onSubmitTest();
  };
  onSubmitTest = (e) => {
    const { policies, suminsured } = this.state;
    const adultRelations = [
      "self",
      "spouse",
      "father",
      "mother",
      "sister",
      "brother",
      "father-in-law",
      "mother-in-law",
      "brother-in-law",
      "sister-in-law",
      "niece",
      "nephew",
      "son-in-law",
      "daughter-in-law",
      "grand-father",
      "grand-mother",
      "grand-child",
      // "son",
      // "daughter",
    ];
    const adultPolicies = policies.filter((p) =>
      adultRelations.includes(p.relation.toLowerCase())
    );
    const childPolicies = policies.filter(
      (p) => !adultRelations.includes(p.relation.toLowerCase())
    );
    // const insuredMemberDetails = policies.map((item) => ({
    const adultDetails = adultPolicies.map((item) => ({
      id: null,
      type: item.relation.toLowerCase(),
      dob: item.birthDate,
      sumInsured: parseInt(suminsured),
      income: item.relation === "self" ? 50000 : null,
      isDeleted: false,
    }));
    const childDetails = childPolicies.map((item, idx) => ({
      id: null,
      type: `child${idx + 1}`, // child1, child2, child3
      dob: item.birthDate,
      sumInsured: parseInt(suminsured),
      income: null,
      isDeleted: false,
    }));
    const insuredMemberDetails = [...adultDetails, ...childDetails];
    const jsonData = {
      sourceId: "6128058a-3ff6-4e38-b712-9ed1b8d1d52e",
      policyType: this.state.covertype,
      policyCase: this.state.plantype,
      sumInsured: parseInt(suminsured),
      pincode: this.state.zipcode,
      quoteId: null,
      insuredMemberDetails,
      //tenure: this.state.tenure,
      // mobile: this.state.mobile,
      // chiemailIdlds: this.state.childs,
      // businesstype: this.state.businesstype,
    };
    const jsonData1 = JSON.stringify(jsonData);
    //const jsonData2 = JSON.stringify(jsonData1);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("integId", 357);
    formData.append("savedata", "yes");
    formData.append("jsonData", JSON.stringify(jsonData1));
    //formData.append("jsonData", this.state.jsonData);
    fetch(configData.api_url + "C_Integrationlibrary/saveJson", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          sessionStorage.setItem("testapidata", JSON.stringify(data.result));
          window.location.href = "/zunoquotes";
          this.setState({ isSuccess: true });
          sessionStorage.setItem("requestId", data.requestId);
        }
      });
  };
  handleSubmit = (e) => {
    const { policies } = this.state;
    var tenurer = this.state.tenure;
    var fd = new FormData();
    let maxage = 0;
    let minage = 0;
    let adults = 0;
    let childs = 0;
    let familydefination = "";
    policies.forEach(function (item) {
      if (minage === 0) minage = item.age;
      if (item.age > maxage) maxage = item.age;
      if (item.age < minage) minage = item.age;
      if (item.age >= 18) adults++;
      else childs++;
      item.dob = item.birthDate;
    });

    fd.append("members", JSON.stringify(policies));
    fd.append("fname", this.state.fname);
    fd.append("lname", this.state.lname);
    fd.append("mobile", this.state.mobile);
    fd.append("zipcode", this.state.zipcode);
    fd.append("plantype", this.state.plantype);
    fd.append("covertype", this.state.covertype);
    fd.append("suminsured", this.state.suminsured);
    fd.append("tenure", tenurer);
    fd.append("businesstype", this.state.businesstype);
    fd.append("emailId", this.state.emailId);
    fd.append("maxage", maxage);
    fd.append("familydefination", familydefination);
    fd.append("adults", adults);
    fd.append("childs", childs);
    fd.append("minage", minage);
    fetch(configData.api_url + "leads/add/", {
      method: "POST",
      mode: "cors",
      body: fd, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({
            policies: [],
          });
          sessionStorage.setItem("proposalId", data.proposalId);
        }
      });
  };
  handleButtonFmClick = () => {
    const allQuestionData = [];
    this.state.policiesTable.forEach((medicals) => {
      this.state.members.forEach((member) => {
        const isChecked =
          this.state.showExistingSince[medicals.caresuprememedicalqns_Id]?.[
            member.relation
          ];
        const dateValue =
          this.state.dateValues[medicals.caresuprememedicalqns_Id]?.[
            member.relation
          ] || "";
        const ans = isChecked ? dateValue : false;

        allQuestionData.push({
          csmqId: medicals.caresuprememedicalqns_Id,
          ans: ans,
          lhmId: member.relation,
          productCode: "",
          questionSetCode: "",
          qnDesc: "",
          questionCode: "",
        });
      });
    });
    this.setState({ allQuestionData }, () => {
      this.handleComplete();
    });
  };
  render() {
    const previousYearStart = new Date();
    previousYearStart.setFullYear(previousYearStart.getFullYear() - 100);
    previousYearStart.setMonth(0);
    previousYearStart.setDate(1);
    const years = Array.from(
      { length: new Date().getFullYear() - 1920 + 1 },
      (v, i) => 1920 + i
    );
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return (
      <div>
        <h3 className="logoskybluecolor">Zunopolicyformpage</h3>
        <Row>
          <Col>
            <Container className="bgalphacolor">
              <Row>
                <Col lg="12" md="12">
                  <div id="accordian">
                    <Card className="card-default">
                      <Card.Body>
                        <Form>
                          <Row>
                            <Col md="4" lg="4">
                              <Form.Group className="form-group">
                                <Form.Label className="control-label">
                                  Mobile No.
                                </Form.Label>
                                <Form.Control
                                  name="mobile"
                                  onKeyDown={this.onKeyDown}
                                  value={this.state.mobile}
                                  onChange={this.handleChange}
                                  type="text"
                                  placeholder="Enter mobile No"
                                  id="mobiles"
                                  maxLength={10}
                                />
                              </Form.Group>
                            </Col>
                            <Col md="4" lg="4">
                              <Form.Group className="form-group">
                                <Form.Label className="control-label">
                                  Enter Your First Name
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="fname"
                                  value={this.state.fname}
                                  onChange={this.handleChange}
                                  placeholder="Enter Your First Name"
                                  id="name"
                                />
                              </Form.Group>
                            </Col>
                            <Col md="4" lg="4">
                              <Form.Group className="form-group">
                                <Form.Label className="control-label">
                                  Enter Your last Name
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  name="lname"
                                  value={this.state.lname}
                                  onChange={this.handleChange}
                                  placeholder="Enter Your Last Name"
                                  id="lname"
                                />
                              </Form.Group>
                            </Col>
                            <Col md="4" lg="4">
                              <Form.Group className="form-group">
                                <Form.Label className="control-label">
                                  Enter The Pin Code
                                </Form.Label>
                                <Form.Control
                                  type="text"
                                  onKeyDown={this.onKeyDown}
                                  id="zipcode"
                                  name="zipcode"
                                  value={this.state.zipcode}
                                  onChange={this.handleChange}
                                  placeholder="Enter zipcode"
                                  maxLength={6}
                                />
                              </Form.Group>
                            </Col>
                            <Col md="4" lg="4">
                              <Form.Group className="form-group">
                                <Form.Label className="control-label">
                                  Email Id
                                </Form.Label>
                                <Form.Control
                                  type="email"
                                  id="emailId"
                                  onKeyDown={this.onKeyDown}
                                  name="emailId"
                                  value={this.state.emailId}
                                  onChange={this.handleChange}
                                  placeholder="Enter Email"
                                />
                              </Form.Group>
                            </Col>
                            <Col md="4" lg="4">
                              <Form.Group className="form-group">
                                <Form.Label className="control-label">
                                  Plan Type
                                </Form.Label>
                                <Form.Select
                                  aria-label="Default select example"
                                  name="plantype"
                                  value={this.state.plantype}
                                  onChange={this.handleChange}
                                  className="form-control"
                                  id="plantype"
                                >
                                  <option>Select </option>
                                  <option value="fresh">Fresh</option>
                                  <option value="port">Port</option>
                                  <option value="renewal">Renewal</option>
                                </Form.Select>
                              </Form.Group>
                            </Col>
                            <Col md="4" lg="4">
                              <Form.Group className="form-group">
                                <Form.Label className="control-label">
                                  Cover Type
                                </Form.Label>
                                <Form.Select
                                  aria-label="Default select example"
                                  name="covertype"
                                  value={this.state.covertype}
                                  onChange={this.handleChange}
                                  className="form-control"
                                  id="covertype"
                                >
                                  <option>Select </option>
                                  <option value="individual">Individual</option>
                                  <option value="floater">Floater</option>
                                </Form.Select>
                              </Form.Group>
                            </Col>
                            <Col md="4" lg="4">
                              <Form.Group className="form-group">
                                <Form.Label className="control-label">
                                  Select Sum Insured
                                </Form.Label>
                                <Form.Select
                                  name="suminsured"
                                  value={this.state.suminsured}
                                  onChange={this.handleChange}
                                  aria-label="Default select example"
                                  className="form-control"
                                  id="suminsured"
                                >
                                  <option>Select </option>
                                  <option value="300000">3 Lakhs</option>
                                  <option value="400000">4 Lakhs</option>
                                  <option value="500000">5 Lakhs</option>
                                  <option value="7500000">75 Lakhs</option>
                                  <option value="1000000">10 Lakhs</option>
                                  <option value="1500000">15 Lakhs</option>
                                  <option value="2000000">20 Lakhs</option>
                                  <option value="2500000">25 Lakhs</option>
                                  <option value="3000000">30 Lakhs</option>
                                  <option value="4000000">40 Lakhs</option>
                                  <option value="5000000">50 Lakhs</option>
                                  <option value="7500000">75 Lakhs</option>
                                  <option value="10000000">1 Crore</option>
                                  <option value="15000000">1.5 Crore</option>
                                  <option value="20000000">2 Crores</option>
                                  <option value="30000000">3 Crores</option>
                                  <option value="40000000">4 Crores</option>
                                </Form.Select>
                              </Form.Group>
                            </Col>
                            <Col md="4" lg="4">
                              <Form.Group className="form-group">
                                <Form.Label className="control-label">
                                  Tenure
                                </Form.Label>
                                <Form.Select
                                  name="tenure"
                                  value={this.state.tenure}
                                  onChange={this.handleChange}
                                  aria-label="Default select example"
                                  className="form-control"
                                  id="tenure"
                                >
                                  <option>Select </option>
                                  <option value="1">1 Year</option>
                                  <option value="2">2 Year</option>
                                  <option value="3">3 Year</option>
                                </Form.Select>
                              </Form.Group>
                            </Col>
                            <Col md="4" lg="4">
                              <Form.Group className="form-group">
                                <Form.Label className="control-label">
                                  Business Type
                                </Form.Label>
                                <Form.Select
                                  name="businesstype"
                                  value={this.state.businesstype}
                                  onChange={this.handleChange}
                                  aria-label="Default select example"
                                  className="form-control"
                                  id="businesstype"
                                >
                                  <option>Select </option>
                                  <option value="New">New Business</option>
                                  <option value="RENEWAL">Renewal</option>
                                  <option value="PORTING">Porting</option>
                                </Form.Select>
                              </Form.Group>
                            </Col>
                          </Row>

                          <Row>
                            <Col className="table-responsive">
                              <Form.Label className="control-label">
                                Insured Details
                              </Form.Label>
                              <table
                                className="table table-bordered table-hover"
                                id="tab_logic"
                              >
                                <thead>
                                  <tr>
                                    <th className="text-center">S.NO</th>
                                    <th className="text-center">Relation</th>
                                    <th className="text-center">
                                      Date Of Birth
                                    </th>
                                    <th className="text-center">Age</th>
                                    <th className="text-center">Gender</th>
                                    <th className="text-center">Actions</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {this.state.policies.length > 0 ? (
                                    this.state.policies.map((quote, index) => (
                                      <tr key={index}>
                                        <td className="text-center">
                                          {index + 1}
                                        </td>
                                        <td className="text-center">
                                          {/* {quote.relation} */}
                                          {this.state.relations.find(
                                            (relation) =>
                                              relation.value === quote.relation
                                          )?.key || ""}
                                        </td>
                                        <td className="text-center">
                                          {this.formatDate(quote.birthDate)}
                                        </td>
                                        <td className="text-center">
                                          {quote.age}
                                        </td>
                                        <td className="text-center">
                                          {/* {quote.gender} */}
                                          {quote.gender === "MALE"
                                            ? "Male"
                                            : quote.gender === "FEMALE"
                                            ? "Female"
                                            : "Female"}
                                        </td>
                                        <td className="actionTDBtn text-right">
                                          <button
                                            type="button"
                                            variant="danger"
                                            className="bi bi-trash-fill btn btn-danger"
                                            onClick={() =>
                                              this.handleRemoveSpecificRowS(
                                                index
                                              )
                                            }
                                          ></button>
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="6"> No Records</td>
                                    </tr>
                                  )}
                                  <tr>
                                    <td style={{ width: "100px" }}>
                                      <div
                                        className="tableListNumber text-center"
                                        style={{ fontSize: "25px" }}
                                      >
                                        <b>
                                          <i
                                            className="bi bi-list-ol"
                                            aria-hidden="true"
                                          ></i>
                                        </b>
                                      </div>
                                    </td>
                                    <td style={{ width: "300px" }}>
                                      <Form.Group className="form-group">
                                        <Form.Select
                                          name="relation"
                                          value={
                                            this.state.policiesData.relation
                                          }
                                          onChange={this.relationChange}
                                          aria-label="Default select example"
                                          className="form-control"
                                          id="relation"
                                          style={{ height: "47px" }}
                                        >
                                          <option>Select</option>
                                          {this.state.relations.map(
                                            (quote, index) => (
                                              <option
                                                key={index}
                                                value={quote.value}
                                                disabled={quote.isDisabled}
                                              >
                                                {quote.key}
                                              </option>
                                            )
                                          )}
                                        </Form.Select>
                                      </Form.Group>
                                    </td>

                                    <td style={{ width: "300px" }}>
                                      <Form.Group className="form-group">
                                        <div calendarClassName="custom-calendar">
                                          <DatePicker
                                            dropdownMode="select"
                                            id="birthDate"
                                            name="birthDate"
                                            className="form-control policiesdatepicker"
                                            selected={
                                              this.state.policiesData.birthDate
                                                ? new Date(
                                                    this.state.policiesData.birthDate
                                                  )
                                                : null
                                            }
                                            maxDate={new Date()}
                                            placeholderText="Select Date Of Birth"
                                            onChange={this.handleDateChange}
                                            dateFormat="dd-MM-yyyy" // Set your desired date format
                                            peekNextMonth
                                            showMonthDropdown
                                            showYearDropdown
                                            minDate={previousYearStart}
                                            renderCustomHeader={({
                                              date,
                                              changeYear,
                                              changeMonth,
                                              decreaseMonth,
                                              increaseMonth,
                                              prevMonthButtonDisabled,
                                              nextMonthButtonDisabled,
                                            }) => (
                                              <div
                                                style={{
                                                  margin: 10,
                                                  display: "flex",
                                                  justifyContent: "center",
                                                }}
                                              >
                                                <button
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    decreaseMonth();
                                                  }}
                                                  disabled={
                                                    prevMonthButtonDisabled
                                                  }
                                                >
                                                  {"<"}
                                                </button>
                                                <select
                                                  value={getYear(date)}
                                                  onChange={({
                                                    target: { value },
                                                  }) => changeYear(value)}
                                                >
                                                  {years.map((option) => (
                                                    <option
                                                      key={option}
                                                      value={option}
                                                    >
                                                      {option}
                                                    </option>
                                                  ))}
                                                </select>

                                                <select
                                                  value={months[getMonth(date)]}
                                                  onChange={({
                                                    target: { value },
                                                  }) =>
                                                    changeMonth(
                                                      months.indexOf(value)
                                                    )
                                                  }
                                                >
                                                  {months.map((option) => (
                                                    <option
                                                      key={option}
                                                      value={option}
                                                    >
                                                      {option}
                                                    </option>
                                                  ))}
                                                </select>

                                                <button
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    increaseMonth();
                                                  }}
                                                  disabled={
                                                    nextMonthButtonDisabled
                                                  }
                                                >
                                                  {">"}
                                                </button>
                                              </div>
                                            )}
                                          />
                                        </div>
                                      </Form.Group>
                                    </td>
                                    <td style={{ width: "200px" }}>
                                      <Form.Group className="form-group">
                                        <Form.Control
                                          name="age"
                                          value={
                                            isNaN(this.state.policiesData.age)
                                              ? 0
                                              : this.state.policiesData.age
                                          }
                                          onChange={this.ageChange}
                                          disabled
                                          readOnly
                                          className="age"
                                          type="text"
                                        />
                                      </Form.Group>
                                    </td>
                                    <td style={{ width: "200px" }}>
                                      <Form.Group className="form-group">
                                        <Form.Select
                                          aria-label="Default select example"
                                          className="form-control"
                                          name="gender"
                                          value={this.state.policiesData.gender}
                                          onChange={this.genderChange}
                                          disabled={this.state.disableGender}
                                          style={{ height: "49px" }}
                                        >
                                          <option value="male">Male</option>
                                          <option value="female">Female</option>
                                          <option value="third gender">
                                            Third Gender
                                          </option>
                                        </Form.Select>
                                      </Form.Group>
                                    </td>
                                    <td className="text-right">
                                      {this.state.isEditing ? (
                                        <Button
                                          type="button"
                                          variant="success"
                                          onClick={this.handleSaveClick}
                                        >
                                          Save
                                        </Button>
                                      ) : (
                                        <Button
                                          type="button"
                                          variant="success"
                                          onClick={this.handleAddClick}
                                          style={{
                                            marginTop: "5px",
                                            padding: "15px 30px",
                                          }}
                                        >
                                          Add
                                        </Button>
                                      )}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </Col>
                          </Row>
                          <Row className="justify-content-between">
                            <Col lg="12" md="12">
                              <Button
                                id="getQuotes4"
                                type="submit"
                                onClick={this.handleSubmitClick}
                                style={{ float: "right" }}
                              >
                                Get Quotes
                              </Button>
                            </Col>
                          </Row>
                        </Form>
                      </Card.Body>
                    </Card>
                  </div>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
      </div>
    );
  }
}
